import { render } from "./koba.vue?vue&type=template&id=47e48b20&scoped=true"
import script from "./koba.vue?vue&type=script&lang=js"
export * from "./koba.vue?vue&type=script&lang=js"

import "./koba.vue?vue&type=style&index=0&id=47e48b20&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e48b20"]])

export default __exports__